var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.031 0.127464C7.6608 0.127464 0.0625 7.8539 0.0625 17.3857C0.0625 25.0109 4.9245 31.4802 11.6666 33.7622C12.5146 33.922 12.826 33.3878 12.826 32.932C12.826 32.5205 12.8103 31.1609 12.8029 29.7188C8.08229 30.7628 7.08617 27.6825 7.08617 27.6825C6.31428 25.6877 5.20212 25.1573 5.20212 25.1573C3.66257 24.0861 5.31817 24.1081 5.31817 24.1081C7.0221 24.2296 7.91931 25.8866 7.91931 25.8866C9.43273 28.5251 11.8889 27.7623 12.8572 27.3213C13.0095 26.2061 13.4492 25.4442 13.9345 25.0135C10.1656 24.5771 6.20357 23.0973 6.20357 16.4843C6.20357 14.6001 6.86643 13.0605 7.9519 11.8519C7.77572 11.4169 7.19491 9.66183 8.11628 7.2846C8.11628 7.2846 9.54119 6.82075 12.7838 9.05366C14.1374 8.67127 15.589 8.4795 17.031 8.47293C18.4731 8.4795 19.9258 8.67127 21.2819 9.05366C24.5206 6.82075 25.9435 7.2846 25.9435 7.2846C26.8671 9.66183 26.2861 11.4169 26.1099 11.8519C27.1979 13.0605 27.8562 14.6001 27.8562 16.4843C27.8562 23.113 23.8867 24.5725 20.1082 24.9998C20.7168 25.5354 21.2591 26.5857 21.2591 28.1958C21.2591 30.5048 21.2394 32.3633 21.2394 32.932C21.2394 33.3913 21.5449 33.9294 22.405 33.7599C29.1435 31.4753 33.9993 25.0084 33.9993 17.3857C33.9993 7.8539 26.4021 0.127464 17.031 0.127464Z",
    fill: "#FEFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48934 24.9066C6.45197 24.9927 6.31934 25.0181 6.19852 24.9592C6.07544 24.9029 6.00632 24.786 6.04622 24.7C6.08275 24.6117 6.21566 24.5874 6.33845 24.646C6.46181 24.7026 6.53205 24.8206 6.48934 24.9066Z",
    fill: "#FEFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17665 25.6863C7.09572 25.7626 6.93752 25.7271 6.83019 25.6065C6.71919 25.4862 6.6984 25.3253 6.78045 25.2479C6.8639 25.1716 7.01733 25.2073 7.1286 25.3276C7.23959 25.4494 7.26123 25.6091 7.17665 25.6863Z",
    fill: "#FEFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84569 26.6803C7.74172 26.7537 7.57172 26.6848 7.46663 26.5314C7.36266 26.3779 7.36267 26.1938 7.46888 26.1201C7.57425 26.0464 7.74172 26.1127 7.84822 26.265C7.95191 26.4208 7.9519 26.6051 7.84569 26.6803Z",
    fill: "#FEFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76229 27.6405C8.66928 27.7449 8.47118 27.7168 8.32619 27.5745C8.17782 27.4353 8.13652 27.2379 8.22981 27.1335C8.32394 27.0289 8.52316 27.0584 8.66928 27.1996C8.81652 27.3385 8.86147 27.5374 8.76229 27.6405Z",
    fill: "#FEFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0267 28.1981C9.98572 28.3333 9.79493 28.3947 9.60273 28.3373C9.41081 28.2781 9.28521 28.1198 9.32399 27.9832C9.36389 27.8472 9.55552 27.7831 9.74913 27.8446C9.94076 27.9035 10.0666 28.0606 10.0267 28.1981Z",
    fill: "#FEFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4154 28.3016C11.4202 28.4439 11.2572 28.5619 11.0555 28.5642C10.8526 28.5691 10.6885 28.4539 10.6862 28.3139C10.6862 28.1701 10.8456 28.0532 11.0484 28.0498C11.2502 28.0458 11.4154 28.1601 11.4154 28.3016Z",
    fill: "#FEFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7077 28.0778C12.7319 28.2167 12.5916 28.3593 12.3913 28.397C12.1943 28.4339 12.012 28.3482 11.9869 28.2104C11.9625 28.0681 12.1052 27.9255 12.3019 27.8886C12.5026 27.8532 12.6821 27.9366 12.7077 28.0778Z",
    fill: "#FEFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.603a6d3322ff5be9800c1e711b92d049.svg";
export { ForwardRef as ReactComponent };